<template>
  <div class="thankyou-layout-bg" :style="backgroundClass">
    <div v-if="backgroundBlur" :style="backgroundImage" />
    <img v-if="backgroundBlur" :src="imageUrl" :style="foregroundImage" />
    <div :style="layerStyles" />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        // baseData: null
      }
    },
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      textColor() {
        return this.baseData.colors && this.baseData.colors.textColor
          ? this.baseData.colors.textColor
          : '#000'
      },
      backgroundClass() {
        if (!this.baseData || !this.baseData.images || !this.baseData.colors) {
          return { background: '#ffcccc', color: '#000' }
        }
        if (
          this.baseData.images.background &&
          this.baseData.images.background.substr(0, 3) === 'url'
        ) {
          const styles = {
            color: this.textColor,
            'font-family': this.baseData.fonts.font,
            background: `${this.baseData.images.background} ${this.baseData.images.backgroundRepeat}`,
          }

          if (this.baseData.images.backgroundRepeat === 'square-fit') {
            Object.assign(styles, {
              background: null,
            })
          }

          if (this.baseData.images.backgroundRepeat === 'stretch') {
            Object.assign(styles, {
              background: this.baseData.images.background,
              'background-position': this.baseData.images.backgroundRepeatAlignment,
              'background-size': 'cover',
              'background-attachment': 'fixed',
            })
          }
          return styles
        } else {
          return {
            background: this.baseData.colors.background || '#ffcccc',
            color: this.textColor,
            'font-family': this.baseData.fonts.font,
            height: '100%',
          }
        }
      },
      backgroundBlur() {
        if (!this.baseData.images) return false
        return !!(
          this.baseData.images.background.substr(0, 3) === 'url' &&
          this.baseData.images.backgroundRepeat === 'square-fit'
        )
      },
      backgroundImage() {
        if (!this.baseData.images) return {}
        return {
          background: this.baseData.images.background,
          position: 'absolute',
          height: '100vh',
          width: 'inherit',
          'background-size': 'cover',
          filter: 'blur(5px)',
          'background-position': 'center',
          'z-index': -1,
        }
      },
      foregroundImage() {
        if (!this.baseData.images) return {}
        return {
          height: '100vh',
          'max-width': '600px',
          position: 'absolute',
          margin: 'auto',
          left: '0',
          right: '0',
          width: '100%',
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'z-index': '2',
        }
      },
      imageUrl() {
        if (this.baseData.images && this.baseData.images.background.substr(0, 3) !== 'url')
          return {}
        const imageUrl = this.baseData.images.background
        return imageUrl.replace(/^url\((.*)\)$/, '$1')
      },
      layerStyles() {
        if (this.baseData && this.baseData.flags && !this.baseData.flags.backgroundLayer) return {}
        if (this.baseData && this.baseData.flags && this.baseData.flags.backgroundLayer) {
          return {
            background: this.baseData.colors.layerColor,
            height: '100%',
            width: '100%',
            position: 'absolute',
            'z-index': '3',
          }
        }
        return {}
      },
    },
  }
</script>

<style lang="scss" scoped>
  .thankyou-layout-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 0;
    pointer-events: none;
  }
</style>
